"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["outerClass", "innerClass", "children", "textAdjust", "style"];

var ShrinkFitContext = /*#__PURE__*/_react.default.createContext(false);

var DEBUG = false;

var ShrinkToFit = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ShrinkToFit, _React$Component);

  var _super = (0, _createSuper2.default)(ShrinkToFit);

  function ShrinkToFit(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ShrinkToFit);
    _this = _super.call(this, props);
    _this.state = {
      innerScale: 1.0,
      prevScale: 1.0,
      innerHeightMax: 0
    };
    _this.outerRef = /*#__PURE__*/_react.default.createRef();
    _this.innerRef = /*#__PURE__*/_react.default.createRef();
    _this.computeLayout = _this.computeLayout.bind((0, _assertThisInitialized2.default)(_this));
    _this.observer = new ResizeObserver(function (entries) {
      /*let max = 0
      for (let entry of entries) {
        for (let h of entry.contentBoxSize) {
          max = Math.max(max, h.blockSize);
        }
        max = Math.max(max, entry.contentRect.height);
      }*/
      _this.computeLayout();
    });
    return _this;
  }

  (0, _createClass2.default)(ShrinkToFit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener("resize", this.computeLayout);
      window.addEventListener("load", this.computeLayout);

      if (this.innerRef.current) {
        this.observer.observe(this.innerRef.current);
      }

      if (this.outerRef.current) {
        this.observer.observe(this.outerRef.current);
      }

      this.computeLayout();
      window.setTimeout(function () {
        _this2.computeLayout();

        window.setTimeout(function () {
          _this2.computeLayout();
        }, 0);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.computeLayout);
      window.removeEventListener("load", this.computeLayout);
      this.observer.disconnect();
    }
  }, {
    key: "computeLayout",
    value: function computeLayout() {
      var _this3 = this;

      if (!this.outerRef.current || !this.innerRef.current) {
        return;
      }

      var outerRect = this.outerRef.current.getBoundingClientRect();
      var innerRect = this.innerRef.current.getBoundingClientRect();
      var scale = Math.min(1, outerRect.width / (innerRect.width / this.state.innerScale));

      if (isNaN(scale)) {
        this.setState({
          innerScale: 1,
          prevScale: this.state.innerScale,
          innerHeight: innerRect.height / this.state.innerScale,
          innerHeightMax: Math.max(this.state.innerHeightMax, innerRect.height)
        });

        if (this.props.onInnerScaleChange !== undefined) {
          this.props.onInnerScaleChange(1);
        }

        window.setTimeout(function () {
          _this3.computeLayout();
        }, 0);
        return;
      }

      if (scale === this.state.prevScale) {
        DEBUG && console.log("ShrinkToFit alternating", this.state.prevScale, this.state.innerScale, scale, "pick smallest", Math.min(scale, this.state.innerScale));
        scale = Math.min(scale, this.state.innerScale);
      }

      if (scale !== this.state.innerScale || innerRect.height !== this.state.innerHeight) {
        this.setState({
          innerScale: scale,
          prevScale: this.state.innerScale,
          innerHeight: innerRect.height * scale / this.state.innerScale,
          innerHeightMax: Math.max(this.state.innerHeightMax, innerRect.height)
        });

        if (this.props.onInnerScaleChange !== undefined) {
          this.props.onInnerScaleChange(scale);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          outerClass = _this$props.outerClass,
          innerClass = _this$props.innerClass,
          children = _this$props.children,
          textAdjust = _this$props.textAdjust,
          style = _this$props.style,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);

      if (this.context) {
        return children;
      }

      var outerHeight = this.state.innerHeight;
      /*=== this.state.innerHeightMax ? 
      this.state.innerHeightMax * this.state.innerScale :
      this.state.innerHeight;*/

      return /*#__PURE__*/_react.default.createElement(ShrinkFitContext.Provider, {
        value: true
      }, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, props, {
        className: "shrinkfit-outer ".concat(outerClass || ''),
        style: (0, _objectSpread2.default)({
          height: outerHeight ? outerHeight + "px" : "1px",
          overflow: this.props.disableClipping ? "visible" : "clip"
        }, style),
        onMouseMove: function onMouseMove(e) {
          _this4.computeLayout();
        },
        ref: this.outerRef
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "shrinkfit-inner ".concat(innerClass || ''),
        style: {
          transform: "scale(".concat(this.state.innerScale, ")"),
          fontSize: textAdjust ? "".concat(1 / this.state.innerScale, "em") : undefined,
          width: "max-content",
          position: "relative",
          transformOrigin: "top left",
          margin: "auto"
        },
        ref: function ref(node) {
          _this4.innerRef.current = node;

          if (node && textAdjust) {
            node.style.setProperty("font-size", "".concat(1 / _this4.state.innerScale, "em"), "important");
          }
        }
      }, children)));
    }
  }]);
  return ShrinkToFit;
}(_react.default.Component);
/*
export default function ShrinkToFit({outerClass, innerClass, children, textAdjust, style, ...props}) {
  const context = React.useContext(ShrinkFitContext)
  const outerRef = React.useRef()
  const innerRef = React.useRef()
  const [[innerScale, innerHeight], setInnerScaleAndHeight] = React.useState([1,])

  const computeLayout = () => {
    if (!outerRef.current || !innerRef.current) {
      return
    }
    let outerRect = outerRef.current.getBoundingClientRect()
    let innerRect = innerRef.current.getBoundingClientRect()
    if (outerRect.width === 0 || innerRect.width === 0) {
      return
    }
    let scale = Math.min(1, outerRect.width / (innerRect.width / innerScale))


    if (scale !== innerScale || innerRect.height !== innerHeight) {
      setInnerScaleAndHeight([scale, innerRect.height])
    }
  }

  React.useLayoutEffect(computeLayout)
  React.useEffect(()=>{
    document.addEventListener("resize", computeLayout)
    computeLayout()
    window.setTimeout(() => {
      computeLayout()
      window.setTimeout(() => {
        computeLayout()
      }, 0)
    }, 0)
    return () => {
      document.removeEventListener("resize", computeLayout)
    }
  })
  
  if (context) {
    return children
  }
  return <ShrinkFitContext.Provider value={true}>
    <div
      {...props}
      className={`shrinkfit-outer ${outerClass || ''}`}
      style={{
        height: innerHeight ? innerHeight + "px" : undefined,
        width: "100%",
        ...style
      }}
      ref={outerRef}
    >
      <div
        className={`shrinkfit-inner ${innerClass || ''}`}
        style={{
          transform: `scale(${innerScale})`,
          fontSize: textAdjust ? `${1 / innerScale}em` : undefined,
          width: "max-content",
          position: "relative",
          transformOrigin: "top left",
          margin: "auto",
        }}
        ref={(node) => {
          innerRef.current = node
          if (node && textAdjust) {
            node.style.setProperty("font-size", `${1 / innerScale}em`, "important")
          }
        }}
      >
        {children}
      </div>
    </div>
  </ShrinkFitContext.Provider>
}
*/


exports.default = ShrinkToFit;
ShrinkToFit.contextType = ShrinkFitContext;